import { useCallback } from 'react';

import { useSetOnboardingState } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { IMPROVE_WRITING_ON_PASTE } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

export const useSetImproveWritingPasteData = () => {
	const { setOnboardingState } = useSetOnboardingState();

	const setImproveWritingPasteData = useCallback(
		async ({
			firstPasteViewed,
			secondPasteViewed,
		}: {
			firstPasteViewed?: boolean;
			secondPasteViewed?: boolean;
		}): Promise<void> => {
			// There should never be a case where the first and second paste can occur at the exact same time
			if (firstPasteViewed) {
				setOnboardingState({
					key: IMPROVE_WRITING_ON_PASTE.FIRST_PASTE_VIEWED,
					value: 'true',
				});
			}
			if (secondPasteViewed) {
				setOnboardingState({
					key: IMPROVE_WRITING_ON_PASTE.SECOND_PASTE_VIEWED,
					value: 'true',
				});
			}
		},
		[setOnboardingState],
	);

	return {
		setImproveWritingPasteData,
	};
};
